import { render } from "./DonateBlock.vue?vue&type=template&id=1ff29fa3"
import script from "./DonateBlock.vue?vue&type=script&lang=js"
export * from "./DonateBlock.vue?vue&type=script&lang=js"

import "./DonateBlock.vue?vue&type=style&index=0&id=1ff29fa3&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__